import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-stone-300">
      <div className="mx-auto max-w-7xl px-6 py-10 sm:px-8 lg:px-12">
        <div className="flex flex-wrap justify-between gap-8">
          <div>
            <p className="font-medium">Trey Reynolds · Polity Interfaces</p>
            <p className="mt-2 text-sm leading-relaxed text-stone-600">
              Independent technical consulting. Austin, Texas.
            </p>
          </div>
          <nav aria-label="Footer navigation" className="flex flex-wrap gap-x-6 gap-y-3 text-sm">
            <a className="text-link" href="https://www.linkedin.com/in/treyreynolds">
              LinkedIn
            </a>
            <a className="text-link" href="https://github.com/treyreynolds">
              GitHub
            </a>
            <Link className="text-link" to="/contact">
              Contact
            </Link>
            <Link className="text-link" to="/privacy">
              Privacy
            </Link>
          </nav>
        </div>
        <p className="mt-8 max-w-2xl text-xs leading-relaxed text-stone-600">
          Consulting is offered independently through Polity Interfaces. Employer names describe
          professional experience and do not imply endorsement.
        </p>
        <p className="mt-3 text-xs text-stone-600">
          © {new Date().getFullYear()} Polity Interfaces
        </p>
      </div>
    </footer>
  );
}
